export default "__VITE_ASSET__CEGjaqEL__"